import Bankid from './Bankid';
export default Bankid;